import {
  type DocumentCategory,
  DOCUMENT_CATEGORIES,
  DOCUMENT_CATEGORY_COLORS,
} from '@seen/core/models/document-references/constants'
import { cn } from '@seen/ui'
import { LabelColor } from '#src/components/LabelColor.tsx'

export function CategoryCircles({
  categories,
  className,
}: {
  categories: DocumentCategory[]
  className?: string
}) {
  if (categories.length === 0) {
    return null
  }

  return (
    <div
      className={cn(
        'space-x-[-0.28125rem] flex rtl:space-x-reverse',
        className
      )}
    >
      {categories.slice(0, 3).map((category) => (
        <div
          key={category}
          className="relative rounded-full border border-white bg-white"
          title={DOCUMENT_CATEGORIES[category]?.display ?? category}
        >
          <LabelColor color={DOCUMENT_CATEGORY_COLORS[category]} />
        </div>
      ))}
    </div>
  )
}
